var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('footer',{staticClass:"fixed-bottom"},[_c('p',{staticClass:"m-0 text-center"},[_vm._v("Copyright © 2021 Delta IT . All Rights Reserved.")])])
}]

export { render, staticRenderFns }